export default __webpack_public_path__ + "static/media/2317.066125e7.png";